const config = {
  ENV: 'staging',
  BASE_API: 'https://ife-api.cinesendstaging.com/api/'
}

export default config